import type { IAccountNotificationsNotes } from './AccountNotificationsNotes.interface';
import AccountNotificationsPreferences from './AccountNotificationsPreferences';

export default class AccountNotificationsNotes implements IAccountNotificationsNotes {
  newMyNote: AccountNotificationsPreferences;
  newMyNoteCP: AccountNotificationsPreferences;
  newMyNotePP: AccountNotificationsPreferences;
  newNote: AccountNotificationsPreferences;
  newNoteDealOwner: AccountNotificationsPreferences;
  newNoteCP: AccountNotificationsPreferences;
  newNotePP: AccountNotificationsPreferences;

  static build = (data: IAccountNotificationsNotes) => new AccountNotificationsNotes(data);
  static blank = () => new AccountNotificationsNotes();

  /**
   * Constructor
   * @param {IAccountNotificationsNotes} data
   */
  constructor(data?: IAccountNotificationsNotes) {
    this.newMyNote = new AccountNotificationsPreferences(data?.newMyNote);
    this.newMyNoteCP = new AccountNotificationsPreferences(data?.newMyNoteCP);
    this.newMyNotePP = new AccountNotificationsPreferences(data?.newMyNotePP);
    this.newNote = new AccountNotificationsPreferences(data?.newNote);
    this.newNoteDealOwner = new AccountNotificationsPreferences(data?.newNoteDealOwner);
    this.newNoteCP = new AccountNotificationsPreferences(data?.newNoteCP);
    this.newNotePP = new AccountNotificationsPreferences(data?.newNotePP);
  }
}
